export const techStack = [
  {
    name: "Javascript",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
  },
  {
    name: "NodeJS",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original-wordmark.svg",
  },
  {
    name: "Express",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/express/express-original-wordmark.svg",
  },
  {
    name: "Mongo DB",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-plain.svg",
  },
  {
    name: "React",
    link: "https://pagepro.co/blog/wp-content/uploads/2020/03/react-native-logo-884x1024.png",
  },
  {
    name: "Redux Toolkit",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/redux/redux-original.svg",
  },
  {
    name: "HTML",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
  },
  {
    name: "CSS",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-plain.svg",
  },
  {
    name: "Bootstrap",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-plain.svg",
  },
  {
    name: "Strapi ",
    link: "https://raw.githubusercontent.com/gilbarbara/logos/52addcaa18dfecb4df77f3ee0753dca6b98187ad/logos/strapi-icon.svg",
  },
  {
    name: "Drupal",
    link: "https://www.vectorlogo.zone/logos/drupal/drupal-icon.svg",
  },
  {
    name: "PHP",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/php/php-original.svg",
  },
  {
    name: "MySQl",
    link: "https://www.vectorlogo.zone/logos/mysql/mysql-icon.svg",
  },
  {
    name: "Postman",
    link: "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
  },
  {
    name: "Git",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-plain.svg",
  },
  {
    name: "C++ Language",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/cplusplus/cplusplus-original.svg",
  },

  // { name: "TypeScript", link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg" },

  // { name: "Dart", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/dart/dart-original.svg" },
  // { name: "Flutter", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-plain.svg" },

  // { name: "Sass", link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/sass/sass-original.svg" },

  // { name: "Webpack", link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/redux/redux-original.svg" },

  // { name: "Heroku", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/heroku/heroku-plain.svg" },
  // { name: "Azure", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-plain.svg" },

  // { name: "BABEL", link: "https:d33wubrfki0l68.cloudfront.net/7a197cfe44548cc1a3f581152af70a3051e11671/78df8/img/babel.svg" },
  // { name: "Firebase", link: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg" },

  // { name: "Bash", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bash/bash-original.svg" },
  // { name: "Vim", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vim/vim-original.svg" },

  // { name: "VS Code", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg" },
  // {name: "", link: "https://repository-images.githubusercontent.com/59065830/b62be480-45d2-11ea-9989-803db0f9c44d"}
];

export const contactLinks = [
  // {
  //   name: "Instagram",
  //   url: "https://img.icons8.com/doodle/40/000000/instagram-new--v2.png",
  //   link: "https://www.instagram.com/manojgum/",
  // },
  {
    name: "Github",
    url: "https://img.icons8.com/doodle/40/000000/github--v1.png",
    link: "https://github.com/manojGum",
  },
  {
    name: "LinkedIn",
    url: "https://img.icons8.com/doodle/40/000000/linkedin--v2.png",
    link: "https://www.linkedin.com/in/manoj-kumar-402b0519b/",
  },
  {
    name: "Resume",
    url: "https://assets.dryicons.com/uploads/icon/svg/7895/3a762adf-69f8-446d-90b3-296d302fd4fc.svg",
    link: "https://drive.google.com/file/d/1yPC88XUyESJ_BVGm0XzG_dcjfAQDV5WK/view?usp=sharing",
  },
];

export const ProjectsData = [
  // {
  //   name: 'Web Application Development',
  //   desc: 'Web design encompasses many different skills and disciplines in the production and maintenance of websites. The different areas of web design include web graphic design user interface design  authoring, including standardised code and proprietary software user experience design and search engine',
  //   img: "https://img.icons8.com/external-kiranshastry-lineal-color-kiranshastry/64/000000/external-web-development-coding-kiranshastry-lineal-color-kiranshastry.png"
  // },
  // {
  //   name: 'Web Application Development',
  //   desc: 'Web design encompasses many different skills and disciplines in the production and maintenance of websites. The different areas of web design include web graphic design user interface design  authoring, including standardised code and proprietary software user experience design and search engine',
  //   img: "https://img.icons8.com/external-kiranshastry-lineal-color-kiranshastry/64/000000/external-web-development-coding-kiranshastry-lineal-color-kiranshastry.png"
  // },
  // {
  //   name: 'Web Application Development',
  //   desc: 'Web design encompasses many different skills and disciplines in the production and maintenance of websites. The different areas of web design include web graphic design user interface design  authoring, including standardised code and proprietary software user experience design and search engine',
  //   img: "https://img.icons8.com/external-kiranshastry-lineal-color-kiranshastry/64/000000/external-web-development-coding-kiranshastry-lineal-color-kiranshastry.png"
  // },
  // {
  //   name: 'Web Application Development',
  //   desc: 'Web design encompasses many different skills and disciplines in the production and maintenance of websites. The different areas of web design include web graphic design user interface design  authoring, including standardised code and proprietary software user experience design and search engine',
  //   img: "https://img.icons8.com/external-kiranshastry-lineal-color-kiranshastry/64/000000/external-web-development-coding-kiranshastry-lineal-color-kiranshastry.png"
  // },
  // {
  //   name: 'Mobile Application Development',
  //   desc: `We provide a range of mobile application development services
  //   including custom mobile development on Android platforms, building
  //   cross-platform apps, designing user experience and integrating
  //   novel mobile interfaces such as chat and voice`,
  //   img: "https://img.icons8.com/external-justicon-lineal-color-justicon/64/000000/external-app-development-responsive-web-design-justicon-lineal-color-justicon.png"
  // },

  // {
  //   name: 'Backend Development',
  //   desc: `Graphic design is a craft where professionals create visual
  //   content to communicate messages. By applying visual hierarchy and
  //   page layout techniques, designers use typography and pictures to
  //   meet users' specific needs and focus on the logic of displaying
  //   elements in interactive designs, to optimize the user experience.`,
  //   img: "https://img.icons8.com/external-flaticons-flat-flat-icons/64/000000/external-backend-no-code-flaticons-flat-flat-icons.png"
  // },

  // {
  //   name: "BBLCreditcardLanding_backend",
  //   img: "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*nssRTzXk7MZYKAtjHFolrA.png",
  //   desc: "",
  //   demo: "https://bandhanbank.com/",
  //   tech: ["html","css","javascript", "ReactJs"],
  //   code: "",
  // },

  {
    name: "Meanbuy",
    img: "https://miro.medium.com/max/1400/1*4b2fWNuz4EZwhufRDuJ0lQ.jpeg",
    desc: `Meanbuy is a E-commerce website the of online shopping platform with varities of products ranging from womens accessories to consumer electronics`,
    demo: "https://mean-buy-com-4wwu-manojgums-projects.vercel.app",
    tech: ["html", "css", "javascript", "Reactjs"],
    code: "https://github.com/manojGum/MeanBuy.com",
  },

  {
    name: "SkinStore",
    img: "https://miro.medium.com/max/700/0*aVJ2OQHcDNuGhr8i.png",
    desc: `SkinStore is a online beauty products worldwie site, There many products avilables where customer can buy avilable products,`,
    demo: " https://skin-store-clone.vercel.app/",
    tech: ["html", "css", "javascript"],
    code: " https://github.com/shoaib-ahmed16/SkinStore-front_end",
  },

  {
    name: "YouTube",
    img: "https://heavy.com/wp-content/uploads/2017/08/youtube-screenshot.png",
    desc: `A simple YouTube clone completed, where user can find all the videos similar as Youtube app. where user can search and watch the videos.`,
    demo: "https://youtubeapp-nu.vercel.app/",
    tech: ["html", "css", "javascript"],
    code: "https://github.com/manojGum/youtubeapp",
  },

  {
    name: "Google translate-clone",
    img: "https://miro.medium.com/max/1400/1*8i_UHgxUOmyCkrOGRYkztw.jpeg",
    desc: `A Google translate - clone completed . With the help of translator we can easily understand any words.`,
    demo: "https://hindi-english-translate.netlify.app/",
    tech: ["html", "css", "javascript"],
    code: "https://github.com/manojGum/Translate",
  },
  // {
  //   name: "codehubindusnettechnologie",
  //   img: "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*WwSdOn-aUstkvdaSEbBeXw.jpeg",
  //   desc: "This service is used to Collect all the newly developed services just like github ,Store all the information for newly developed projects and services that are utilized on another website, and manage all the related data.",
  //   tech: ["html", "css", "javascript", "ReactJs", "Strapi", "Mysql"],
  //   demo: "https://codehub.indusnettechnologies.com/dashboards",
  //   code: "",
  // },
];


export const githubstatus = [

  {
    link: "https://github-readme-stats.vercel.app/api/top-langs?username=manojgum&show_icons=true&locale=en&layout=compact",
  },
  {
    link: "https://github-readme-stats.vercel.app/api?username=manojgum&show_icons=true&locale=en",
  },
  {
    link: "https://github-readme-streak-stats.herokuapp.com/?user=manojgum",
  },
];